const routes = [{
  path: '/feiche/batch',
  component: () => import('@/views/feiche/batch/order'),
  name: 'feiche-batch',
  meta: {
    title: '批单订单'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/feiche/batch.js